module.exports = __webpack_public_path__ + "assets/media/morning.1c5693b4.mp3";